import { useContext, useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { AppContext } from '../all';

type ActivityRate = {
    id: number;
    name: string;
};

type Props = {
    activityId: number;
    caption: string;
    defVal: number;
    onChange: (value: number) => void;
};

/**
 * SttSelectActivityRate: draw a <select> featuring activity rates.
 * string name - control name.
 * string caption - text field caption.
 * string defVal - currently selected rate.
 * function onChange - callback for when an option is selected.
 */

export function SttSelectActivityRate({
    activityId,
    caption,
    defVal,
    onChange,
}: Props): React.ReactElement {
    const cxt = useContext(AppContext)!;
    const [options, setOptions] = useState<ActivityRate[]>();

    const loadActivityRates = () => {
        cxt?.api('GET', `/activities/${activityId}/rates`, {
            params: { page: 1, rows: 500 },
            success: (r: { activityRates: ActivityRate[] }) => {
                setOptions(r.activityRates);
            },
        });
    };

    useEffect(() => {
        loadActivityRates();
    }, [activityId]);

    return options && options.length > 0 ? (
        <FormControl variant="outlined" size="small" style={{ width: '100%' }}>
            <InputLabel>{caption}</InputLabel>
            <Select
                value={defVal}
                onChange={(e: any) => onChange(e.target.value as number)}
            >
                {options &&
                    options.map((op, i) => (
                        <MenuItem key={i} value={op.id}>
                            {op.name}
                        </MenuItem>
                    ))}
            </Select>
        </FormControl>
    ) : (
        <></>
    );
}
